module.exports = __webpack_public_path__ + "static/media/dollar.2d9de9c4.svg";